module.exports = __webpack_public_path__ + "img/ETH.002602c9.svg";